import { initStartupScripts } from './index';

// This entrypoint intentionally runs at module load from index.html.
initStartupScripts();
